export const APP_NAME: string = 'bo';
export const MAIN_CONTENT_ID: string = 'main-content';
export const TABLE_PAGE_SIZE_OPTIONS_DEFAULT: number[] = [20, 50, 100];
export enum LimiterLength {
    CharString = 100,
    VarCharString = 255,
    MinInteger = -2147483648,
    MaxInteger = 2147483647,
    PageItemsSize = 20,
    DiscountProgramCouponsSearchResults = 1000,
}
